import lozad from 'lozad';

const observer = lozad('.lozad', {
    loaded: function(el){
        el.style.removeProperty('min-height');
    }
});
observer.observe();

$(function () {
    $('img.lozad').each(function () {
        const originalWidth = $(this).attr('data-original-width');
        const originalHeight = $(this).attr('data-original-height');
        const ratio = originalHeight / originalWidth;

        const width = $(this).width();
        const height = width * ratio;
        // console.log(`${$(this).attr('data-src')}`)
        // console.log(`${width} ${height} ${ratio}`);
        // console.log('---------------')
        $(this).css('min-height', `${height}px`);
    });

    $('video.lozad').each(function () {
        const width = $(this).width();
        const ratio = 0.57
        const height = width * ratio;
        $(this).css('min-height', `${height}px`);
    });

    // $('video').each(function () {
    //     console.log('vids');
    //     console.log($(this).height());
    //     console.log($(this)[0].videoHeight);
    //     console.log($(this).parent());
    // });
    $(window).on('load', function(){
        console.log('trigger lazy load image');
        $('.lozad').each(function(){
            observer.triggerLoad($(this)[0]);
        });
        // const lozad = document.querySelector('.lozad');
    });
})
